module.exports = __webpack_public_path__ + "FixelDisplay-ThinItalic.8a35caf9b425a2aaa30f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelDisplay/FixelDisplay-ThinItalic.woff2
// module id = ./src/assets/webfonts/fixelDisplay/FixelDisplay-ThinItalic.woff2
// module chunks = styles